export default "__VITE_ASSET__hUF495qT__"